module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'aio') ? _c('EquipmentAIODetail') : (_vm.type === 'aio2') ? _c('EquipmentAIOTwoDetail') : (_vm.type === 'box') ? _c('EquipmentBoxDetail') : (_vm.type === 'box-venue') ? _c('EquipmentBoxVenueDetail') : (_vm.type === 'sit') ? _c('EquipmentSitDetail') : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-281c7c4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/EquipmentDetail.vue
// module id = 974
// module chunks = 0